<app-page-header-nav
    [title]="'Order Details'"
    [navItems]="navigationItems"
></app-page-header-nav>
